<script setup>
import { defineAsyncComponent } from "vue";

const AuthLayout = defineAsyncComponent(() =>
    import("../../Layouts/AuthLayout.vue")
);

const ProjectVideoUploader = defineAsyncComponent(() =>
    import(
        "../../components/Logistics/ProjectVideoDashboard/VideoUploader.vue"
    )
);

const props = defineProps({
    project_id: {
        type: String,
        required: true,
    },
});
</script>

<template>
    <ProjectVideoUploader :project_id="props.project_id" />
</template>
